import React, { useCallback, useEffect, useMemo } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import HeaderDropdown from "./components/dropdown";
import constants from "./../../constants";
import { useGetNotifications } from "repositories/notification-repository";
import { useGetMessangerOwnerList } from "repositories/chat-repository";
import withMessageCount from "hoc/withMessageCount";
import useSubscriptionAccess from "hooks/useSubscriptionAccess";
import { useForegroundNotifications } from "hooks/useForegroundNotifications";
import useNotificationClickNavigation from "hooks/useNotificationClickNavigation";
import { useToGetSubsModuleAccess } from "repositories/subscription-repository";
import Loader from "components/Loader";
import { Link } from "react-router-dom";
import { chatNotEnabled } from "patient-scheduling/wrapper";
import MessageCountHook from "Messenger/count";

const Header = (props) => {
  let page = 1;
  let itemPerPage = 1;
  let listRequired = false;
  const {
    isModuleDisabledClass,
    redirectWithCheck,
    isModuleDisabledClassForStaff,
  } = useSubscriptionAccess();
  const profile = useSelector((pre) => pre.userProfile?.profile);

  const { isOwner, isPatient, isStaff, isSuperAdmin, ownerId } = useMemo(
    () => ({
      isOwner: profile?.role?.systemRole === constants.systemRoles.accountOwner,
      isStaff: profile?.role?.systemRole === constants.systemRoles.staff,
      isPatient: profile?.role?.systemRole === constants.systemRoles.patient,
      isSuperAdmin:
        profile?.role?.systemRole === constants.systemRoles.superAdmin,
      ownerId: profile?.id,
    }),
    [profile?.role],
  );
  const newNotification = useSelector((e) => e.notification);
  const dispatch = useDispatch();
  const { data: apiData } = useGetNotifications(
    itemPerPage,
    page,
    listRequired,
  );

  const { data, isLoading } = useToGetSubsModuleAccess(ownerId, {
    enabled:
      !!ownerId &&
      profile?.role?.systemRole !== constants.systemRoles.superAdmin &&
      profile?.role?.systemRole !== constants.systemRoles.patient,
  });
  const { data: ownerData } = useGetMessangerOwnerList(null, {
    enabled:
      !!profile?.id &&
      profile?.role?.systemRole !== constants.systemRoles.superAdmin,
  });

  const getModuleStatus = (moduleId) => {
    if (!profile?.role?.systemRole) return "";
    return profile?.role?.systemRole === constants.systemRoles.accountOwner
      ? isModuleDisabledClass(moduleId)
      : isModuleDisabledClassForStaff(moduleId);
  };
  const isDisabledClass = {
    liveChat: getModuleStatus(constants.moduleNameWithId.teamLiveChat),
    scheduler: getModuleStatus(constants.moduleNameWithId.scheduler),
    taskManagement: getModuleStatus(constants.moduleNameWithId.taskManagement),
    notesAndReminder: getModuleStatus(
      constants.moduleNameWithId.notesAndReminder,
    ),
    patientConversation: getModuleStatus(
      constants.moduleNameWithId.patientConversation,
    ),
    patientAppointment: getModuleStatus(
      constants.moduleNameWithId.patientAppointment,
    ),
  };

  useEffect(() => {
    if (data) {
      dispatch({
        type: constants.SUBSCRIPTIONMODULEADDED,
        payload: data,
      });
    }
  }, [data]);

  useEffect(() => {
    if (ownerData) {
      dispatch({
        type: constants.OWNERMESSAENGERMODULEADDED,
        payload: ownerData,
      });
    } else {
      dispatch({
        type: constants.OWNERMESSAENGERMODULEADDED,
        payload: {},
      });
    }
  }, [ownerData]);

  useEffect(() => {
    if (apiData && apiData?.data?.newNotifications) {
      dispatch({ type: constants.NOTIFICATIONUNREAD });
    }
  }, [apiData]);

  const handleForegroundMessage = useCallback(() => {
    dispatch({ type: constants.NOTIFICATIONUNREAD });
  }, [dispatch]);

  useForegroundNotifications(handleForegroundMessage);
  useNotificationClickNavigation();

  let logo = null;
  const condtionFirst = profile && !profile.isAccountOwnerSetup;
  const condtionSecond = profile && profile.isAccountOwnerSetup;
  const condtionThree = profile.profileSetupStep !== "packageExpired";
  if (condtionFirst && isOwner) {
    logo = (
      <Link to="/account">
        <img
          src={require("assets/images/home-logo.svg").default}
          className="img-fluid"
          alt="logo"
        />
      </Link>
    );
  }
  if (
    condtionSecond &&
    isOwner &&
    (profile.profileSetupStep === "completed" ||
      profile.profileSetupStep === "packageExpired" ||
      profile.profileSetupStep === "subscriptionTerminated")
  ) {
    logo = (
      <Link to="/Offices">
        <img
          src={require("assets/images/home-logo.svg").default}
          className="img-fluid"
          alt="logo"
        />
      </Link>
    );
  } else if (
    condtionSecond &&
    isOwner &&
    profile.profileSetupStep !== "completed" &&
    condtionThree &&
    profile.profileSetupStep !== "subscriptionTerminated"
  ) {
    logo = (
      <img
        src={require("assets/images/home-logo.svg").default}
        className="img-fluid"
        alt="logo"
      />
    );
  } else if (profile && isStaff) {
    logo = (
      <Link to="/">
        <img
          src={require("assets/images/home-logo.svg").default}
          className="img-fluid"
          alt="logo"
        />
      </Link>
    );
  } else if (profile && isSuperAdmin) {
    logo = (
      <Link to="/manage-owner">
        <img
          src={require("assets/images/home-logo.svg").default}
          className="img-fluid"
          alt="logo"
        />
      </Link>
    );
  } else if (profile && isPatient) {
    logo = (
      <Link to={constants.routes.doctors}>
        <img
          src={require("assets/images/home-logo.svg").default}
          className="img-fluid"
          alt="logo"
        />
      </Link>
    );
  }
  const sendbirdCountHook = useMemo(
    () =>
      !profile?.id ||
      !profile?.role?.systemRole ||
      (chatNotEnabled.includes(profile?.role?.systemRole) &&
        !profile?.isPatientChat),
    [profile],
  );
  return (
    <header>
      {isLoading && <Loader />}
      <div className="container-fluid custom-logo">
        <div className="row no-gutters align-items-center">
          <div className="col-4">
            <div className="logo">{logo}</div>
          </div>
          {!sendbirdCountHook && <MessageCountHook />}
          <div className="col-8 text-right header-right">
            <HeaderDropdown
              ProviderName={props.ProviderName}
              newNotification={newNotification}
              dispatch={dispatch}
              isDisabledClass={isDisabledClass}
              redirectWithCheck={redirectWithCheck}
            />
          </div>
        </div>
      </div>
    </header>
  );
};
const mapStateToProps = ({ userProfile: { profile } }) => ({
  profile,
});
export default connect(mapStateToProps, null)(withMessageCount(Header));
